import { TStorage } from '../basis/types/tstorage';

export const setLocalUserName = (name: string) => {
  localStorage.setItem(TStorage.KEY_USER_NAME, name);
};

export const getLocalUserName = () => {
  return localStorage.getItem(TStorage.KEY_USER_NAME);
};
